'use client';

import { useAnimate } from 'motion/react';
import { useEffect } from 'react';

import { cn } from '@/utils/cn';

import styles from './Loading.module.scss';
import {
  APiece,
  CPiece,
  EPiece,
  IPiece,
  RPiece,
  TPiece,
  VPiece,
} from './pieces';

export const Loading: React.FC = () => {
  const [scope, animate] = useAnimate();

  useEffect(() => {
    const letters = [
      '.vPiece',
      '.ePiece',
      '.rPiece',
      '.tPiece',
      '.iPiece',
      '.cPiece',
      '.aPiece',
    ];

    const sequence: any[] = [];

    letters.forEach((selector, index) => {
      const delay = index * 0.75;

      sequence.push([
        selector,
        { opacity: 1, y: 0 },
        { type: 'spring', stiffness: 300, damping: 20, at: delay },
      ]);

      sequence.push([
        selector,
        { y: 48 },
        { type: 'spring', stiffness: 150, damping: 18, at: delay + 0.3 },
      ]);

      sequence.push([
        selector,
        { y: 96 },
        { type: 'spring', stiffness: 120, damping: 16, at: delay + 1 },
      ]);

      sequence.push([
        selector,
        { opacity: 0 },
        { duration: 0.15, at: delay + 1.2 },
      ]);
    });

    animate(sequence, {
      repeat: Infinity,
      repeatDelay: 0.5, // Faster loop restart
    });
  }, [animate]);

  return (
    <div ref={scope}>
      <div className={styles.wrapper}>
        <VPiece
          className={cn(styles.piece, 'vPiece')}
          initial={{
            opacity: 0,
            y: -48,
          }}
        />
        <EPiece
          className={cn(styles.piece, 'ePiece')}
          initial={{
            opacity: 0,
            y: -48,
          }}
        />
        <RPiece
          className={cn(styles.piece, 'rPiece')}
          initial={{
            opacity: 0,
            y: -48,
          }}
        />
        <TPiece
          className={cn(styles.piece, 'tPiece')}
          initial={{
            opacity: 0,
            y: -48,
          }}
        />
        <IPiece
          className={cn(styles.piece, 'iPiece')}
          initial={{
            opacity: 0,
            y: -48,
          }}
        />
        <CPiece
          className={cn(styles.piece, 'cPiece')}
          initial={{
            opacity: 0,
            y: -48,
          }}
        />
        <APiece
          className={cn(styles.piece, 'aPiece')}
          initial={{
            opacity: 0,
            y: -48,
          }}
        />
      </div>
    </div>
  );
};
